import styled from 'styled-components';

export const TooltipsStyles = styled.section`
  display: inline-flex;
  align-items: center;
  column-gap: 12px;
`;
